import {UserOutlined} from "@ant-design/icons";
import {Button, Tooltip} from "antd";
import {useNavigate} from "react-router-dom";
import {UtilsService} from "../../services/Utils.service";
import {RoutingURL} from "../../model/models";

interface UserDetailsButtonProps {
    personID?: number,
    combinatorID?: number,
    forceReload?: boolean;
}

export default function UserDetailsButton({personID, combinatorID, forceReload = false}: Readonly<UserDetailsButtonProps>) {
    const navigate = useNavigate();

    function goUserDetails() {
        let url
        if (combinatorID)
            url = UtilsService.replaceUserAndCombinatorID(RoutingURL.USERDETAILSPRACTICES, personID?.toString(), combinatorID?.toString())
        else
            url = UtilsService.replaceId(RoutingURL.USERDETAILS, personID?.toString())

        if (forceReload) {
            navigate(url);
            navigate(0);
        } else {
            navigate(url);
        }
    }

    return (
        <>
            <Tooltip title={"Vai al fascicolo"}>
                <Button type="primary" shape="circle"
                        icon={<UserOutlined/>}
                        onClick={goUserDetails}
                />
            </Tooltip>
        </>
    )

}